import { FadingScrollable, HotkeyHint } from '@renderer/chat'
import { Modal } from '../index'
import useTriggerHotkey from '@renderer/hooks/useTriggerHotkey'
import { useGlobalStore } from '@highlight/ipc/react'
import { getDefaultVoiceHotkey } from '@shared/store/impl/settings'
import { isMac } from '@shared/utils/platform'

const cmdOrCtrl = isMac ? 'cmd' : 'ctrl'

const HotkeyItem = ({ label, hotkey }: { label: string; hotkey: string }) => {
  return (
    <div className={'hover:bg-border/5 flex items-center justify-between rounded-lg p-1.5 ps-2'}>
      {label}
      <HotkeyHint hotkey={hotkey} />
    </div>
  )
}

export const HotkeysOverviewModal = () => {
  const assistantHotkey = useTriggerHotkey()
  const [voiceModeHotkey] = useGlobalStore<string>('settings', 'hotkeys.voiceMode', getDefaultVoiceHotkey())

  return (
    <Modal>
      <Modal.Content className="overflow-hidden">
        <Modal.Header>
          <Modal.Title>Hotkeys Overview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <FadingScrollable
            className={'text-foreground-secondary flex flex-col gap-1 text-sm font-normal'}
            fadeSize="30%"
          >
            <span className={'text-foreground-secondary text-md mb-1.5 font-medium'}>Global Hotkeys</span>
            <HotkeyItem label={'Show/hide on-screen assistant'} hotkey={assistantHotkey} />
            <HotkeyItem label={'Hide on-screen assistant'} hotkey={'esc'} />
            <HotkeyItem label={'Create new task'} hotkey={`${cmdOrCtrl} + shift + space`} />
            <HotkeyItem label={'Use voice mode'} hotkey={`${voiceModeHotkey}`} />
            <span className={'text-foreground-secondary text-md mb-1.5 mt-4 font-medium'}>Chat Hotkeys</span>
            <HotkeyItem label={'Type into apps'} hotkey={'tab'} />
            <HotkeyItem label={'Start new chat'} hotkey={`${cmdOrCtrl} + n`} />
            <HotkeyItem label={'Go to home'} hotkey={`${cmdOrCtrl} + h`} />
            <HotkeyItem label={'Search'} hotkey={`${cmdOrCtrl} + k`} />
            <HotkeyItem label={'Send a message without attachments'} hotkey={`${cmdOrCtrl} + enter`} />
            <HotkeyItem label={'Use off-screen words'} hotkey={`${cmdOrCtrl} + j`} />
            <HotkeyItem label={'Reset attachments'} hotkey={`${cmdOrCtrl} + shift + del`} />
            <HotkeyItem label={'Scroll to bottom'} hotkey={`${cmdOrCtrl} + arrowdown`} />
            <HotkeyItem label={'Scroll to top'} hotkey={`${cmdOrCtrl} + arrowup`} />
            <HotkeyItem label={'Maximize assistant chat'} hotkey={`${cmdOrCtrl} + m`} />
          </FadingScrollable>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  )
}
